import React, { Component } from 'react';
import { parse, stringify } from 'query-string';
import { sanitizeLinkUrl } from '@helpers/deeplinks';

class ChangePasswordScene extends Component {

  componentWillMount() {
    document.body.classList.add('change-password');
  }

  componentWillUnmount() {
    document.body.classList.remove('change-password');
  }

  render() {
    const session = parse(this.props.location.search);
    // The reset context (access-token, client, expiry, uid) rides along in the
    // query string, so an unvalidated deep_link handed that to whoever crafted
    // the link. Only the mobile app's own scheme or a Go4 host may receive it.
    const url = sanitizeLinkUrl(session.deep_link);
    session.deep_link = undefined;
    return (
      <div className="changePassword">
        <h1>Change your password!</h1>
        {url ? (
          <React.Fragment>
            <p>Please open the following link on your mobile device.</p>
            <a href={`${url}?${stringify(session)}`} className="btn btn-primary px-4">
              Change password
            </a>
          </React.Fragment>
        ) : (
          <p>
            This password reset link is not valid. Please request a new one from the Go4 app.
          </p>
        )}
      </div>
    );
  }
}

export default ChangePasswordScene;
